import {
    getDataModelProp,
} from "~/stateGetter";

export default function resetItem(state, model) {
    let { modelId } = model;


    let initialModel = getDataModelProp(state, modelId, 'stateModel');

    return {
        ...model,
        item: {
            ...initialModel.item,
            id: model.item.id
        },
        itemData: initialModel.itemData
    }
}